import { ContentBlock } from './content-block';

export type ContentBlocks = Readonly<{
    [key: number]: ContentBlock;
}>;

export const initialContentBlocksState: ContentBlocks = {};
